import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  searchGroupedBaskets,
  selectUserBasketSearchData,
} from '@epicuro-next/state/basket-switch-state';
import { select, Store } from '@ngrx/store';
import { BasketSlim, UserBaskets } from 'graphql-api/baskets-api-interfaces';

@Component({
  selector: 'epc-grouped-baskets',
  templateUrl: './grouped-baskets.component.html',
  styleUrls: ['./grouped-baskets.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GroupedBasketsComponent implements OnInit {
  @Input() public activeBasketId: string;
  @Input() public allLoaded = false;
  @Input() public loading = false;

  @Input()
  public set searchTerm(search: string) {
    if (search !== undefined) {
      this.store.dispatch(searchGroupedBaskets({ refNumber: search }));
      this.open = !!search?.trim().length;
      this.toggles = {};
    }
  }

  /** List of open close flags for accordions */
  public toggles: { [key: string]: boolean } = {};

  public open = false;

  public searchData$ = this.store.pipe(select(selectUserBasketSearchData));

  constructor(private store: Store) {}

  public ngOnInit() {
    this.store.dispatch(searchGroupedBaskets({}));
  }

  public isActive(basketId: string) {
    return this.activeBasketId === basketId.replace(/-/g, '');
  }

  public onScroll() {
    if (!this.loading && !this.allLoaded) {
      this.store.dispatch(searchGroupedBaskets({}));
    }
  }

  public handleToggled({ open, id }: { id: string; open: boolean }) {
    this.toggles[id] = open;
  }

  public isOpened(id: string) {
    return this.open || this.toggles[id];
  }

  public trackByUserId(_: number, userBasket: UserBaskets) {
    return userBasket.user?.id;
  }

  public trackByBasketId(_: number, basket: BasketSlim) {
    return basket.id;
  }
}
